import { ERROR_STATUS } from 'site-modules/shared/constants/financing/financing';

export const MOCK_PREQUALIFY_ID = '9fd41940-231b-11ed-a0d5-2b0d5010f747';

const commonFinancingOffersData = {
  applicationId: MOCK_PREQUALIFY_ID,
  type: 'update',
};

const commonOfferData = {
  vehicleStructure: {
    vehicle: {
      vin: '1HGBH41JXMN109186',
      stockNumber: '112342',
      make: 'Tesla',
      model: 'Model S',
      trim: 'SE',
      year: '2010',
      mileage: 60000,
      imageUrl: 'https://www.topspeed.com/cars/tesla/2010-tesla-model-s-ar72390/pictures.html',
      wholesaleValue: 28000.0,
      condition: 'CertifiedPreowned',
      bodyStyle: 'Sedan',
      location: {
        dealerName: 'Tesla Motors of Texas',
        dealerId: '11890',
        city: 'Plano',
        stateCode: 'TX',
        distance: 10.0,
      },
    },
    dealStructure: {
      salesPrice: 30000.0,
      rebateAmount: 1000.0,
      vehicleTradeInDetail: {
        make: 'Honda',
        model: 'CRV',
        year: '2008',
        vehicleValuationAmount: 5000.0,
        remainingBalance: 0.0,
      },
      downPayment: 1000.0,
    },
    financeProducts: [
      {
        productAmount: 1500.0,
        productType: 'OtherFrontEnd',
        productCategory: 'FrontEnd',
      },
    ],
    fees: [
      {
        feeAmount: 0.3552526305636262,
        feeType: 'SalesTax',
        productCategory: 'BackEnd',
      },
    ],
  },
  saveOffer: {
    isSaved: false,
  },
  vehicleOfferId: 'faed0003-8213-4b76-ac7c-9ed5dbd48bc8',
  lenderId: 'COF',
};

export const offer24 = {
  ...commonOfferData,
  responseCode: 'Success',
  financeInformation: {
    loanTerm: 24,
    amountToFinance: 30253.0,
    monthlyPayment: 750.0,
    buyRate: 0.51,
    maximumParticipationRate: 0.44,
    dealerFee: 500.0,
    participationFlat: {
      value: 0.23,
      unit: 'Percentage',
    },
  },
  counters: [
    {
      counteredOn: 'DownPayment',
      counterType: 'MinimumValueNotMet',
      suggestedValue: {
        value: 1500.0,
        unit: 'USD',
      },
      offByRequestedValue: {
        value: 0.35,
        unit: 'Percentage',
      },
    },
  ],
};

export const offer36 = {
  ...commonOfferData,
  responseCode: 'Success',
  financeInformation: {
    loanTerm: 36,
    amountToFinance: 30253.0,
    monthlyPayment: 564.0,
    buyRate: 0.51,
    maximumParticipationRate: 0.44,
    dealerFee: 500.0,
    participationFlat: {
      value: 0.23,
      unit: 'Percentage',
    },
  },
  counters: [
    {
      counteredOn: 'DownPayment',
      counterType: 'MinimumValueNotMet',
      suggestedValue: {
        value: 1500.0,
        unit: 'USD',
      },
      offByRequestedValue: {
        value: 0.35,
        unit: 'Percentage',
      },
    },
  ],
};
export const offer48 = {
  ...commonOfferData,
  responseCode: 'Success',
  financeInformation: {
    loanTerm: 48,
    amountToFinance: 30253.0,
    monthlyPayment: 426.0,
    buyRate: 0.51,
    maximumParticipationRate: 0.44,
    dealerFee: 500.0,
    participationFlat: {
      value: 0.23,
      unit: 'Percentage',
    },
  },
  counters: [
    {
      counteredOn: 'DownPayment',
      counterType: 'MinimumValueNotMet',
      suggestedValue: {
        value: 1500.0,
        unit: 'USD',
      },
      offByRequestedValue: {
        value: 0.35,
        unit: 'Percentage',
      },
    },
  ],
};
const offer60 = {
  ...commonOfferData,
  responseCode: 'Success',
  financeInformation: {
    loanTerm: 60,
    amountToFinance: 30253.0,
    monthlyPayment: 386.0,
    buyRate: 0.51,
    maximumParticipationRate: 0.44,
    dealerFee: 500.0,
    participationFlat: {
      value: 0.23,
      unit: 'Percentage',
    },
  },
  counters: [
    {
      counteredOn: 'DownPayment',
      counterType: 'MinimumValueNotMet',
      suggestedValue: {
        value: 1500.0,
        unit: 'USD',
      },
      offByRequestedValue: {
        value: 0.35,
        unit: 'Percentage',
      },
    },
  ],
};

const offer72 = {
  ...commonOfferData,
  responseCode: 'Success',
  financeInformation: {
    loanTerm: 72,
    amountToFinance: 30253.0,
    monthlyPayment: 305.0,
    buyRate: 0.51,
    maximumParticipationRate: 0.44,
    dealerFee: 500.0,
    participationFlat: {
      value: 0.23,
      unit: 'Percentage',
    },
  },
  counters: [
    {
      counteredOn: 'DownPayment',
      counterType: 'MinimumValueNotMet',
      suggestedValue: {
        value: 1500.0,
        unit: 'USD',
      },
      offByRequestedValue: {
        value: 0.35,
        unit: 'Percentage',
      },
    },
  ],
};

const OFFERS_DOWN_PAYMENT_LOW = [
  {
    ...offer24,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'DownPayment',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 1000.0,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer36,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'DownPayment',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 1000.0,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer48,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'DownPayment',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 1000.0,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer60,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'DownPayment',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 1000.0,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer72,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'DownPayment',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 1000.0,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
];

const OFFERS_DOWN_PAYMENT_HIGH = [
  {
    ...offer24,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'DownPayment',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 2000.0,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer36,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'DownPayment',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 2000.0,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer48,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'DownPayment',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 2000.0,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer60,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'DownPayment',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 2000.0,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer72,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'DownPayment',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 2000.0,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
];

const OFFERS_LOAN_TERM_LOW = [
  {
    ...offer24,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'LoanTerm',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 24,
          unit: 'Months',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer36,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'LoanTerm',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 24,
          unit: 'Months',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer48,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'LoanTerm',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 24,
          unit: 'Months',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer60,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'LoanTerm',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 24,
          unit: 'Months',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer72,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'LoanTerm',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 24,
          unit: 'Months',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
];

const OFFERS_LOAN_TERM_HIGH = [
  {
    ...offer24,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'LoanTerm',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 72,
          unit: 'Months',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer36,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'LoanTerm',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 72,
          unit: 'Months',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer48,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'LoanTerm',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 72,
          unit: 'Months',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer60,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'LoanTerm',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 72,
          unit: 'Months',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer72,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'LoanTerm',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 72,
          unit: 'Months',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
];

const OFFERS_ATF_LOW = [
  {
    ...offer24,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'AmountToFinance',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 4000,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer36,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'AmountToFinance',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 4000,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer48,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'AmountToFinance',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 4000,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer60,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'AmountToFinance',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 4000,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer72,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'AmountToFinance',
        counterType: 'MinimumValueNotMet',
        suggestedValue: {
          value: 4000,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
];

export const OFFERS_ATF_HIGH = [
  {
    ...offer24,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'AmountToFinance',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 30000,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer36,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'AmountToFinance',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 30000,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer48,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'AmountToFinance',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 30000,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer60,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'AmountToFinance',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 30000,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
  {
    ...offer72,
    responseCode: 'OutOfPolicy',
    counters: [
      {
        counteredOn: 'AmountToFinance',
        counterType: 'MaximumValueExceeded',
        suggestedValue: {
          value: 30000,
          unit: 'USD',
        },
        offByRequestedValue: {
          value: 0.35,
          unit: 'Percentage',
        },
      },
    ],
  },
];

export const financingOffers = {
  'capOne-approved': {
    ...commonFinancingOffersData,
    offers: [offer24, offer36, offer48, offer60, offer72],
    status: 'Approved',
  },
  'capOne-paymentsSuccess': {
    ...commonFinancingOffersData,
    offers: [offer24, offer36, offer48, offer60, offer72],
    status: 'Approved',
  },
  'capOne-paymentsCounter-downPayment-tooLow': {
    ...commonFinancingOffersData,
    offers: OFFERS_DOWN_PAYMENT_LOW,
    status: 'Approved',
  },
  'capOne-paymentsCounter-downPayment-tooHigh': {
    ...commonFinancingOffersData,
    offers: OFFERS_DOWN_PAYMENT_HIGH,
    status: 'Approved',
  },
  'capOne-paymentsCounter-amountToFinance-tooLow': {
    ...commonFinancingOffersData,
    offers: OFFERS_ATF_LOW,
    status: 'Approved',
  },
  'capOne-paymentsCounter-amountToFinance-tooHigh': {
    ...commonFinancingOffersData,
    offers: OFFERS_ATF_HIGH,
    status: 'Approved',
  },
  'capOne-paymentsCounter-loanTerm-tooLow': {
    ...commonFinancingOffersData,
    offers: OFFERS_LOAN_TERM_LOW,
    status: 'Approved',
  },
  'capOne-paymentsCounter-loanTerm-tooHigh': {
    ...commonFinancingOffersData,
    offers: OFFERS_LOAN_TERM_HIGH,
    status: 'Approved',
  },
  'capOne-paymentsCounter-partially': {
    ...commonFinancingOffersData,
    offers: [
      offer24,
      offer36,
      { ...offer48, responseCode: 'OutOfPolicy' },
      { ...offer60, responseCode: 'OutOfPolicy' },
      { ...offer72, responseCode: 'OutOfPolicy' },
    ],
    status: 'Approved',
  },
  paymentCountersPartDifferentTriggers: {
    ...commonFinancingOffersData,
    offers: [offer24, offer36, OFFERS_DOWN_PAYMENT_HIGH[0], OFFERS_DOWN_PAYMENT_HIGH[1], OFFERS_LOAN_TERM_HIGH[2]],
  },
  'capOne-paymentsCounter-differentTriggers': {
    ...commonFinancingOffersData,
    offers: [
      OFFERS_DOWN_PAYMENT_HIGH[0],
      OFFERS_DOWN_PAYMENT_HIGH[1],
      OFFERS_LOAN_TERM_HIGH[2],
      OFFERS_LOAN_TERM_HIGH[3],
      OFFERS_LOAN_TERM_HIGH[4],
    ],
    status: 'Approved',
  },
  paymentCountersDifferentWithoutTriggers: {
    ...commonFinancingOffersData,
    offers: [
      { ...OFFERS_DOWN_PAYMENT_HIGH[0], counters: {} },
      { ...OFFERS_DOWN_PAYMENT_HIGH[1], counters: {} },
      { ...OFFERS_LOAN_TERM_HIGH[2], counters: {} },
      { ...OFFERS_LOAN_TERM_HIGH[3], counters: {} },
      { ...OFFERS_LOAN_TERM_HIGH[4], counters: {} },
    ],
  },

  'capOne-paymentsCounter-unsupportedError': {
    ...commonFinancingOffersData,
    status: 'Error',
  },

  'capOne-approvedTermsMissed': {
    offers: [
      { ...offer24, responseCode: 'MaximumLimitExceeded' },
      { ...offer36, responseCode: 'MaximumLimitExceeded' },
      { ...offer48, responseCode: 'MaximumLimitExceeded' },
      { ...offer60, responseCode: 'MaximumLimitExceeded' },
      { ...offer72, responseCode: 'MaximumLimitExceeded' },
    ],
    status: 'Approved',
  },
  'capOne-systemError': { ...commonFinancingOffersData, status: 'Error' },
  'capOne-vehicleNotFound': {
    ...commonFinancingOffersData,
    status: 'VehicleNotFound',
  },
};

export const NOTIFICATION_MSG = 'One or more terms was not approved by the lender.';
export const NOTIFICATION_MSG_NO_COUNTERS =
  ' cannot display pre-qualified financing terms for this vehicle. You may be able to adjust your terms. If adjusting your terms does not work, then you may contact the dealer directly for other financing options';

export const COUNTERS = ['DownPayment', 'LoanTerm', 'AmountToFinance'];

export const UNIT_DEFINITION = {
  USD: '$',
  Percentage: '%',
  Months: 'months',
};

export const COUNTER_DEFINITIONS = {
  DownPayment: {
    counterName: 'Down payment',
    problemType: { MinimumValueNotMet: 'low', MaximumValueExceeded: 'high' },
  },
  LoanTerm: {
    counterName: 'Loan term',
    problemType: { MinimumValueNotMet: 'low', MaximumValueExceeded: 'high' },
  },
  AmountToFinance: {
    counterName: 'Amount to finance',
    problemType: { MinimumValueNotMet: 'low', MaximumValueExceeded: 'high' },
  },
};

export const FEATURE_FLAGS = {
  vehiclePricingPolling: [
    'capOne-approvedTermsMissed',
    'capOne-systemError',
    'capOne-paymentsSuccess',
    'capOne-paymentsCounter-downPayment-tooLow',
    'capOne-paymentsCounter-downPayment-tooHigh',
    'capOne-paymentsCounter-amountToFinance-tooLow',
    'capOne-paymentsCounter-amountToFinance-tooHigh',
    'capOne-paymentsCounter-loanTerm-tooLow',
    'capOne-paymentsCounter-loanTerm-tooHigh',
    'capOne-paymentsCounter-partially',
    'capOne-paymentsCounter-differentTriggers',
    'capOne-paymentsCounter-unsupportedError',
    'capOne-approved',
    'capOne-vehicleNotFound',
  ],
  prequalify: ['capOne-approved', 'capOne-systemError'],
  offersPolling: [
    'capOne-approved',
    'capOne-declined',
    'capOne-pendingFurtherReview',
    'capOne-systemError',
    'capOne-approvedTermsMissed',
    'capOne-vehicleNotFound',
  ],
};

export const mockOffersPollingData = {
  'capOne-approved': {
    offers: [offer24, offer36, offer48, offer60, offer72],
    applicationId: MOCK_PREQUALIFY_ID,
    status: 'Approved',
    type: 'prequalify',
  },
  'capOne-approvedTermsMissed': {
    offers: [
      { ...offer24, responseCode: 'MaximumLimitExceeded' },
      { ...offer36, responseCode: 'MaximumLimitExceeded' },
      { ...offer48, responseCode: 'MaximumLimitExceeded' },
      { ...offer60, responseCode: 'MaximumLimitExceeded' },
      { ...offer72, responseCode: 'MaximumLimitExceeded' },
    ],
    applicationId: MOCK_PREQUALIFY_ID,
    status: 'Approved',
    type: 'prequalify',
  },
  'capOne-declined': {
    applicationId: MOCK_PREQUALIFY_ID,
    status: 'Declined',
    type: 'prequalify',
  },
  'capOne-pendingFurtherReview': {
    applicationId: MOCK_PREQUALIFY_ID,
    status: 'PendingFurtherReview',
    type: 'prequalify',
  },
  'capOne-systemError': {
    applicationId: MOCK_PREQUALIFY_ID,
    status: 'Error',
    type: 'prequalify',
  },
  'capOne-vehicleNotFound': {
    applicationId: MOCK_PREQUALIFY_ID,
    status: 'VehicleNotFound',
    type: 'prequalify',
  },
};

export const mockPrequalifyData = {
  'capOne-approved': {
    offers: [offer24, offer36, offer48, offer60, offer72],
    applicationId: MOCK_PREQUALIFY_ID,
    status: 'Approved',
    type: 'existing_prequalify',
  },
  'capOne-systemError': {
    status: 'Error',
    type: 'existing_prequalify',
  },
};

export const MOCK_NAME = 'MockApproved';

export const MOCK_APPROVED_RESPONSE = {
  offers: [offer24, offer36, offer48, offer60, offer72],
  status: ERROR_STATUS.APPROVED,
  applicationId: MOCK_PREQUALIFY_ID,
};

export const MOCK_PERSONAL_INFO = {
  firstName: 'MockApproved',
  lastName: 'Doe',
  email: 'email@test.com',
  phoneNumber: '3103103101',
  zipCode: '12345',
};

// offersPolling OFFERS_POOLING prequalify
// prequalify PREQUALIFY getPreExistingApplications
// vehiclePricingPolling PRICING getOffers
